import React from 'react';

interface WhisperMessageConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

export const WhisperMessageConfig: React.FC<WhisperMessageConfigProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs text-blue-700 leading-relaxed">
        <strong>Como funciona:</strong> Envia uma mensagem de <strong>sussurro</strong> (sistema) que é visível <strong>apenas para os operadores</strong> no Bitrix24. O cliente/usuário final <strong>não vê</strong> essa mensagem. Útil para enviar informações internas, contexto sobre o cliente ou instruções para o atendente durante uma conversa. Suporta variáveis usando <code className="bg-blue-100 px-1 rounded">{'{{nome_variavel}}'}</code>.
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Mensagem (sussurro)
        </label>
        <textarea
          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          rows={4}
          placeholder="Ex: Cliente VIP - Nome: {{nome}}, Último pedido: {{ultimo_pedido}}"
          value={config.message || ''}
          onChange={(e) => onChange('message', e.target.value)}
        />
      </div>
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-xs text-amber-700 leading-relaxed">
        <strong>⚠ Atenção:</strong> Esta mensagem usa o parâmetro <code className="bg-amber-100 px-1 rounded">SYSTEM=Y</code> do Bitrix24. Ela aparece como uma nota do sistema no chat e é visível apenas para operadores/atendentes.
      </div>
    </div>
  );
};
